import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_TOTAL_REVENUE_BY_YEAR } from "../Schema/Dashboard";

const useGetTotalRevenueByYear = ({ year }) => {
  const [loading, setLoading] = useState(true);
  const [totalData, setTotalData] = useState(0);

  const { refetch } = useQuery(GET_TOTAL_REVENUE_BY_YEAR, {
    variables: {
      year,
    },
    onCompleted: ({ getTotalRevenueByYear }) => {
      setTotalData(getTotalRevenueByYear || 0);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [year]);

  return { totalData, loading };
};

export default useGetTotalRevenueByYear;
